// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"b3e3dcd2f04c9880f023","821":"e306f919217e47f6fe12","926":"d0d3c57d9dbedd989fd5"}[chunkId] + ".chunk.js";
};